


















import { defineComponent, useRoute, computed } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    page: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    window: {
      type: Number,
      default: 2
    }
  },
  setup(props) {
    const route = useRoute()

    const isFirst = computed(() => props.page <= 1)
    const isLast = computed(() => props.page >= props.total)
    const to = (page: number) => {
      const query = { ...route.value.query }

      // URLに ?page=1 が付かないようにする
      if (page > 1) {
        query.page = page.toString()
      } else {
        delete query.page
      }

      return {
        path: route.value.path,
        query
      }
    }

    return {
      isFirst,
      isLast,
      to
    }
  }
})

export interface PaginationHeaders {
  total: string
  'per-page': string
}

export function calculateTotalFromHeaders(headers: PaginationHeaders) {
  const total = parseInt(headers.total)
  const per = parseInt(headers['per-page'])
  return Math.floor(total / per) + (total % per > 0 ? 1 : 0)
}
